/** Константы фестиваля ARENA (TAKE). Все даты — по Стамбулу (UTC+3, без перехода на летнее время). */
export const ARENA_TZ = "Europe/Istanbul";

/** Начало фестиваля: 24.10.2026 00:00 (Стамбул). */
export const ARENA_START = new Date("2026-10-24T00:00:00+03:00");
/** Конец фестиваля: 25.10.2026 23:59 (Стамбул). */
export const ARENA_END = new Date("2026-10-25T23:59:59+03:00");
/** С какого момента можно присоединиться: 21.10.2026 00:00 (Стамбул). */
export const ARENA_JOIN_FROM = new Date("2026-10-21T00:00:00+03:00");
/** До какого момента можно присоединиться: 26.10.2026 23:59 (Стамбул). Это же окно плитки и пункта меню. */
export const ARENA_JOIN_UNTIL = new Date("2026-10-26T23:59:59+03:00");

/** Дни фестиваля (число месяца октября). */
export const ARENA_DAYS = [24, 25] as const;

export const ARENA_FIRST_MEETING_DRIVES = 10;
export const ARENA_NEXT_MEETING_DRIVES = 5;
export const ARENA_MAX_REWARDED_MEETINGS = 5;

export const ARENA_PATH = "/arena";
export const ARENA_PEOPLE_PATH = "/arena/people";

/** Ступени счётчика «Знакомств» (по числу подтверждённых встреч, без лимита наград). */
export const ARENA_MILESTONES = [1, 3, 5, 10] as const;

/** Круг-партнёр ARENA (приглашение внизу /arena/people). Пусто — блок не показываем. */
export const ARENA_PARTNER_CIRCLE_ID = "8aafd8ee-6d44-491e-8c9b-761baab8b2a7";
